/* batida-cookie-settings.js: "Ustawienia cookies" in the footer (both hosts; sections/batida-v7-footer.liquid and
   sections/footer.liquid, links [data-cookie-settings]). Changing consent must be as easy as giving it (29.09, legal):
   the link reopens Shopify's own cookie preferences - window.privacyBanner.showPreferences(), the API of Shopify's
   privacy banner (checked on this store: storefront-banner.js exposes boot / loadBanner / showBanner / showPreferences;
   the preferences dialog opens with Accept all / Reject all / Save choices). The banner script loads itself async; if it
   isn't there yet the click waits for it (up to 4 s), and if it never came it loads the same script Shopify uses. */
(function () {
  'use strict';
  if (window.__batidaCookieSettings) return;
  window.__batidaCookieSettings = true;
  var SRC = '/cdn/shopifycloud/privacy-banner/storefront-banner.js';
  function ready() { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; }
  function open() { try { window.privacyBanner.showPreferences(); return true; } catch (e) { return false; } }
  function whenReady(ms) {
    return new Promise(function (res) {
      var t0 = Date.now();
      (function poll() { if (ready()) return res(true); if (Date.now() - t0 > ms) return res(false); setTimeout(poll, 100); })();
    });
  }
  function load() {
    return new Promise(function (res) {
      if (document.querySelector('script[src*="privacy-banner/storefront-banner"]')) return res();
      var s = document.createElement('script'); s.src = SRC; s.async = true; s.onload = s.onerror = function () { res(); };
      document.head.appendChild(s);
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cookie-settings]');
    if (!a) return;
    e.preventDefault();
    if (ready()) { open(); return; }
    whenReady(4000).then(function (ok) {
      if (ok) return open();
      return load().then(function () { return whenReady(4000); }).then(function (ok2) {
        if (ok2) { if (window.privacyBanner.loadBanner) { try { window.privacyBanner.loadBanner(); } catch (x) {} } open(); }
      });
    });
  });
})();
